<template>
  <div class="progress-wrap" :class="shape" :style="wrapStyle">
    <div class="progress-bg" :style="bgStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'ZuCircleProgress',
  props: {
    duration: { type: [Number, String], default: 600 },
    height: { type: [Number, String], default: 10 },
    // butt | round | square  平头 圆角端头
    shape: { type: String, default: 'round' },
    progress: { type: Number, default: 0 },
    bgColor: { type: String, default: '' },
    progressColor: { type: String, default: '' },
  },
  computed: {
    wrapStyle() {
      const h = Number(this.height) || ''
      const obj = {
        backgroundColor: this.bgColor,
      }
      if (h) {
        obj.height = h + 'rem'
      }
      return obj
    },
    bgStyle() {
      const obj = {
        backgroundColor: this.progressColor,
        width: this.displayPercent + '%',
      }
      const v = Number(this.duration)
      const d = v ? 0 : v / 1000
      if (d) {
        obj.transition = `width ${d}s ease-in-out`
      }
      return obj
    }
  },
  watch: {
    progress: {
      handler(val) {
        this.change(val)
      },
      immediate: true
    }
  },
  data() {
    return {
      displayPercent: 0
    }
  },
  methods: {
    change(val) {
      const num = Number(val) || 0
      setTimeout(() => {
        this.displayPercent = num
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  &-wrap {
    height: 10rem;
    background-color: #f3f3f3;
    &.round {
      border-radius: 100rem;
      .progress-bg { 
        border-radius: 100rem;
      }
    }
    &.square { 
      border-radius: 4rem;
      .progress-bg { 
        border-radius: 4rem;
      }
    }
  }
  &-bg {
    height: 100%;
    background-color: #4B84E6;
    transition: width 0.6s ease-in-out;
  }
}
</style>